var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4706_11515)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.99054,
    cy: 7.99054,
    r: 7.61554,
    stroke: "currentColor",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.24648 9.62019H7.5007V8.98095C7.5007 8.78207 7.52201 8.60451 7.56462 8.44825C7.61434 8.28489 7.67826 8.13928 7.75639 8.01143C7.84163 7.88358 7.93396 7.76994 8.0334 7.6705C8.13994 7.56396 8.24648 7.46097 8.35302 7.36153L8.65134 7.09518C8.8289 6.95313 8.97451 6.78977 9.08815 6.6051C9.2089 6.42043 9.26927 6.18959 9.26927 5.91258C9.26927 5.71371 9.23376 5.53614 9.16273 5.37988C9.0917 5.22362 8.99582 5.09222 8.87507 4.98568C8.75432 4.87914 8.61227 4.79746 8.44891 4.74064C8.29265 4.68382 8.12218 4.6554 7.93751 4.6554C7.55397 4.6554 7.24145 4.7726 6.99996 5.00699C6.76557 5.24138 6.61996 5.53969 6.56314 5.90193L5.83867 5.77408C5.94521 5.22007 6.1867 4.7868 6.56314 4.47429C6.94669 4.15466 7.41546 3.99485 7.96948 3.99485C8.25358 3.99485 8.51994 4.03747 8.76853 4.1227C9.02423 4.20083 9.24441 4.32158 9.42908 4.48494C9.61375 4.6412 9.75936 4.83652 9.8659 5.07091C9.97954 5.3053 10.0364 5.57165 10.0364 5.86997C10.0364 6.09725 10.0115 6.29613 9.96178 6.46659C9.91206 6.63706 9.84104 6.78977 9.7487 6.92472C9.66347 7.05967 9.56048 7.18397 9.43973 7.29761C9.31899 7.40415 9.19114 7.51424 9.05619 7.62789C8.90703 7.74863 8.77918 7.85872 8.67264 7.95816C8.57321 8.0576 8.49152 8.16414 8.4276 8.27778C8.36368 8.38432 8.31751 8.50507 8.2891 8.64002C8.26069 8.77497 8.24648 8.93833 8.24648 9.13011V9.62019ZM8.52349 11.1544C8.52349 11.3035 8.47022 11.4385 8.36368 11.5592C8.25714 11.6729 8.11863 11.7297 7.94817 11.7297C7.7777 11.7297 7.6392 11.6729 7.53266 11.5592C7.42612 11.4385 7.37285 11.3035 7.37285 11.1544C7.37285 11.0052 7.42612 10.8738 7.53266 10.7602C7.6392 10.6394 7.7777 10.5791 7.94817 10.5791C8.11863 10.5791 8.25714 10.6394 8.36368 10.7602C8.47022 10.8738 8.52349 11.0052 8.52349 11.1544Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4706_11515"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9811,
    height: 15.9811,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpOutline);
export default __webpack_public_path__ + "static/media/help-outline.1e33137a1d6b432ad79c420f9edfd7dc.svg";
export { ForwardRef as ReactComponent };